(function() {
  function initCardSliders() {
    document.querySelectorAll('[data-slider]').forEach(function(slider) {
      if (slider.dataset.sliderInit) return;
      slider.dataset.sliderInit = 'true';

      var figure = slider.closest('.product-card__figure');
      if (!figure) return;

      var slides = Array.from(slider.querySelectorAll('[data-slide]'));
      var dots = Array.from(figure.querySelectorAll('[data-dot]'));
      var current = 0;

      if (slides.length <= 1) return;

      function goTo(index) {
        slides[current].classList.remove('is-active');
        if (dots[current]) dots[current].classList.remove('is-active');
        current = index;
        slides[current].classList.add('is-active');
        if (dots[current]) dots[current].classList.add('is-active');
      }

      // Dot tıklama
      dots.forEach(function(dot) {
        dot.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          goTo(parseInt(dot.dataset.dot));
        });
        dot.addEventListener('mousedown', function(e) {
          e.preventDefault();
          e.stopPropagation();
        });
        dot.addEventListener('touchend', function(e) {
          e.preventDefault();
          e.stopPropagation();
          goTo(parseInt(dot.dataset.dot));
        });
      });

      // Drag başlamasın
      slider.addEventListener('dragstart', function(e) {
        e.preventDefault();
      });

      // Mouse drag
      var mouseStartX = 0;
      var mouseStartY = 0;
      var isDragging = false;
      var dragMoved = false;

      slider.addEventListener('mousedown', function(e) {
        mouseStartX = e.clientX;
        mouseStartY = e.clientY;
        isDragging = true;
        dragMoved = false;
      });

      window.addEventListener('mousemove', function(e) {
        if (!isDragging) return;
        if (Math.abs(e.clientX - mouseStartX) > 5) {
          dragMoved = true;
        }
      });

      window.addEventListener('mouseup', function(e) {
        if (!isDragging) return;
        isDragging = false;
        var diff = mouseStartX - e.clientX;
        if (Math.abs(diff) > 40) {
          if (diff > 0) {
            goTo(current + 1 < slides.length ? current + 1 : 0);
          } else {
            goTo(current - 1 >= 0 ? current - 1 : slides.length - 1);
          }
        }
      });

      slider.addEventListener('click', function(e) {
        if (dragMoved) {
          e.preventDefault();
          e.stopPropagation();
          dragMoved = false;
        }
      });

      // Touch/swipe
      var touchStartX = 0;

      slider.addEventListener('touchstart', function(e) {
        touchStartX = e.changedTouches[0].screenX;
      }, { passive: true });

      slider.addEventListener('touchend', function(e) {
        var diff = touchStartX - e.changedTouches[0].screenX;
        if (Math.abs(diff) > 40) {
          if (diff > 0) {
            goTo(current + 1 < slides.length ? current + 1 : 0);
          } else {
            goTo(current - 1 >= 0 ? current - 1 : slides.length - 1);
          }
        }
      }, { passive: true });
    });
  }

  document.addEventListener('DOMContentLoaded', function() {
    initCardSliders();
    new MutationObserver(initCardSliders).observe(document.body, { childList: true, subtree: true });
  });
})();







